module.exports = __webpack_public_path__ + "img/onboard.444406e5.png";